import type { IconSvgObject } from './types';

const EthereumIcon: IconSvgObject = [
  ["path", { d: "M18.5 11.9999L12 14.5L5.5 11.9999M5 11.9999L12 1.99994L19 11.9999L12 21.9999L5 11.9999Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default EthereumIcon;
